(async () => {
  if ('ResizeObserver' in window === false) {
    const mod = await import('resize-observer-polyfill')
    window.ResizeObserver = mod.default
  }
})()
